import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { isEqual } from 'lodash';
import Carousel from '../Carousel/CarouselLegacyWrapper';
import { SHOPS, DOM_GREETING_SECTION } from '../../../../lib/constants';
import ShopCard from '../ShopCard/ShopCard';
import { saveShop, removeShopById } from '../../../../lib/user';
import { addItemsToDataLayer } from '../../../../lib/dataLayerUtils';
import { toSlug } from '../../../../lib/utils';

const PAGE_CONTEXT = 'greeting-section-shops';

const GreetingSectionShopsCarousel = (props) => {
  const {
    pageStateModifiers,
    locale,
    greetingSectionShops,
    mobileGridStyle,
  } = props;

  if (!greetingSectionShops || !greetingSectionShops.length) {
    return null;
  }

  const itemsToDisplay = greetingSectionShops.map((i) => {
    const item = Object.assign({}, i);
    item.isFavourite = true;
    item.dataContextContainer = DOM_GREETING_SECTION;
    item.pageContext = PAGE_CONTEXT;
    item.trackingLocation = `page:${DOM_GREETING_SECTION}-`;
    return item;
  });

  const carouselKey = uuidv4();

  return (
    <div>
      {/* Swiper needs to remount when the content inside changes because it does not handle UI changes well.
      So we set a new ID every single time using UUID to force a unmount and new mount. */}
      <Carousel
        key={carouselKey}
        items={itemsToDisplay}
        itemType={SHOPS}
        Comp={ShopCard}
        removeItemHandler={removeShopById}
        saveItemHandler={saveShop}
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        carouselKey={carouselKey}
        mobileGridStyle={mobileGridStyle}
        spaceBetweenSlides={16}
      />
    </div>
  );
};

class GreetingSectionShops extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favShops: [],
    };

    this.linkDataLayerToShops = this.linkDataLayerToShops.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if the items have changed
    if (!isEqual(this.state.favShops, nextState.favShops)) {
      return true;
    }
  }

  linkDataLayerToShops(shops) {
    const itemType = toSlug(SHOPS);

    // Generate ID for dataLayer
    const linkedShops = shops.map((i) => {
      if (i && i.slug) {
        const newItem = Object.assign({}, i);
        newItem.dataLayerId = `${itemType}_${toSlug(i.slug)}`;
        return newItem;
      }
      return i;
    });

    return linkedShops;
  }


  // Analytics: generates IDs for items
  componentWillMount() {
    const mappedShops = this.linkDataLayerToShops(this.props.userShopsData);

    // Save only the necessary data of items to dataLayer (we do not want isFavs and contextContainer)
    this.setState({ favShops: mappedShops });
  }

  // Analytics: Update dataLayer with new items
  componentDidMount() {
    const favShops = this.state.favShops;

    if (window) {
      addItemsToDataLayer(favShops, SHOPS);
    }
  }

  componentWillReceiveProps(nextProps) {
    const mappedShops = this.linkDataLayerToShops(nextProps.userShopsData);

    // Save only the necessary data of items to dataLayer (we do not want isFavs and contextContainer)
    this.setState({ favShops: mappedShops });
  }

  render() {
    const {
      pageStateModifiers,
      locale,
      mobileGridStyle,
    } = this.props;

    const favShops = this.state.favShops;

    if (!favShops || !favShops.length) {
      return null;
    }

    return (
      <GreetingSectionShopsCarousel
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        greetingSectionShops={favShops}
        mobileGridStyle={mobileGridStyle}
      />
    );
  }
}

export default GreetingSectionShops;
